import React, { useState } from 'react';
import useOnclickOutside from 'react-cool-onclickoutside';
import styles from './style.module.scss';
import { ReactComponent as ChevronDown } from '../Header/assets/ArrowBottom.svg';

interface DropdownOption {
  value: string | number;
  label: string;
}

interface DropdownProps {
  options: DropdownOption[];
  onSelect: (value: string | number) => void;
  defaultValue?: string | number;
  label: string;
  className?: string;
}

export const Dropdown: React.FC<DropdownProps> = ({ options, onSelect, defaultValue, label, className }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(defaultValue || options[0]?.value);
  
  const ref = useOnclickOutside(() => {
    setIsOpen(false);
  });

  const handleSelect = (option: DropdownOption) => {
    setSelectedValue(option.value);
    onSelect(option.value);
    setIsOpen(false);
  };
  
  const selectedLabel = options.find(opt => opt.value === selectedValue)?.label;

  return (
    <div className={`${styles.Dropdown} ${className || ''}`} ref={ref}>
      <label className={styles.Dropdown__label}>{label}</label>
      <div className={styles.Dropdown__header} onClick={() => setIsOpen(!isOpen)}>
        <span>{selectedLabel}</span>
        <ChevronDown className={`${styles.Dropdown__chevron} ${isOpen ? styles.Dropdown__chevron_open : ''}`} />
      </div>
      {isOpen && (
        <ul className={styles.Dropdown__list}>
          {options.map((option) => (
            <li
              key={option.value}
              className={`${styles.Dropdown__item} ${option.value === selectedValue ? styles.Dropdown__item_selected : ''}`}
              onClick={() => handleSelect(option)}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}; 